import { render, staticRenderFns } from "./WarningPanel.vue?vue&type=template&id=492f4e79&scoped=true"
import script from "./WarningPanel.vue?vue&type=script&lang=js"
export * from "./WarningPanel.vue?vue&type=script&lang=js"
import style0 from "./WarningPanel.vue?vue&type=style&index=0&id=492f4e79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492f4e79",
  null
  
)

export default component.exports